import { Box, HStack, Skeleton, Text, useDisclosure } from '@chakra-ui/react';
import { useNotificationsContext } from '../../context/NotificationsContext';
import { AddPartnerCard } from './AddPartnerCard';
import { AddPartnerModal } from './AddPartnerModal';
import { PartnerCard } from './PartnerCard';

export const PartnersSection = () => {
  const { partners, loadingPartners, refetchPartners } =
    useNotificationsContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box pb={4}>
      <Text color="white" fontSize="2xl" fontWeight="medium" mb={4}>
        Partners
      </Text>
      <HStack
        css={{
          '&::-webkit-scrollbar': {
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '4px',
          },
        }}
        overflowX="auto"
        pb={2}
        spacing={3}
      >
        {loadingPartners ? (
          <>
            <Skeleton borderRadius="lg" height="130px" minWidth="130px" />
            <Skeleton borderRadius="lg" height="130px" minWidth="130px" />
            <Skeleton borderRadius="lg" height="130px" minWidth="130px" />
            <Skeleton borderRadius="lg" height="130px" minWidth="130px" />
          </>
        ) : (
          <>
            {partners.map((partner) => (
              <PartnerCard key={partner.id} partner={partner} />
            ))}
            <AddPartnerCard onAddPartner={onOpen} />
          </>
        )}
      </HStack>

      <AddPartnerModal
        isOpen={isOpen}
        onClose={onClose}
        onSuccess={refetchPartners}
      />
    </Box>
  );
};
